const map = {
	"./background-circle-light.png": [
		8421,
		[
			8421
		]
	],
	"./background-circle.png": [
		2758,
		[
			2758
		]
	],
	"./background-light.png": [
		9536,
		[
			9536
		]
	],
	"./background.png": [
		8019,
		[
			8019
		]
	],
	"./logo.svg": [
		7861,
		[
			7861
		]
	]
};
function webpackAsyncContext(req) {
	try {
		if(!__webpack_require__.o(map, req)) {
			return Promise.resolve().then(() => {
	const e = new Error("Cannot find module '" + req + "'");
	e.code = 'MODULE_NOT_FOUND';
	throw e;
});
		}
	} catch(err) {
		return Promise.reject(err);
	}

	const ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1][0]).then(() => (__webpack_require__.t(id, 1 | 16)));
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 766;
module.exports = webpackAsyncContext;